<template>
  <van-list class="tn-van-list">
    <template v-if="swipeCell">
      <van-swipe-cell v-for="(item, index) in list" :key="index" v-bind="$attrs">
        <template slot="left">
          <slot slot="left" name="left"></slot>
        </template>
        <van-cell v-bind="$attrs" @click="$emit('click', item)" :clickable="clickable">
          <template slot="icon">
            <slot name="icon" :row="item"></slot>
          </template>
          <template slot="title">
            <slot name="title" :row="item"></slot>
          </template>
          <template slot="right-icon">
            <slot name="right-icon" :row="item"></slot>
          </template>
          <slot :row="item"></slot>
        </van-cell>
        <template slot="right">
          <slot slot="right" name="right"></slot>
        </template>
      </van-swipe-cell>
    </template>
    <template v-else>
      <van-cell v-for="(item, index) in list" :key="index" v-bind="$attrs" @click="$emit('click', item)"
                :clickable="clickable" :center="true">
        <template slot="icon">
          <slot name="icon" :row="item"></slot>
        </template>
        <template slot="title">
          <slot name="title" :row="item"></slot>
        </template>
        <template slot="right-icon">
          <slot name="right-icon" :row="item"></slot>
        </template>
        <slot :row="item"></slot>
      </van-cell>
    </template>
  </van-list>
</template>
<script>
  export default {
    name: 'tn-list',
    props: {
      list: {
        type: Array,
        required: true
      },
      swipeCell: Boolean,
      clickable: true
    }
  };
</script>
